import { Helmet } from "react-helmet"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import Header from "../../../components/Header"
import Layout from "../../../components/Layout"
import ThumbnailImage from "../../../images/thumbnails/cr_thumb.png"

export function Index() {
  return (
    <Layout
      title="Currency Research Financial Networking Success with Premagic AI Photos"
      description="Currency Research enhanced networking and professional engagement at financial events with AI-driven photo distribution and fintech solutions."
      keywords={[
        "Currency Research case study, financial industry events, forex conference photos, financial networking events, currency trading conferences, financial research events, fintech conference technology, financial industry networking, banking conference photos, financial services events, investment conference management, financial market events, trading conference solutions, financial industry technology, monetary policy conferences",
      ]}
      metaImage={ThumbnailImage}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
        { name: "Currency Research", url: "/case-study/currency-research/" },
      ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "Currency Research Financial Networking Success with Premagic AI Photos",
            "description": "Currency Research enhanced networking and professional engagement at financial events with AI-driven photo distribution and fintech solutions.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2024-01-15",
            "dateModified": "2025-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.CURRENCYRESEARCH} />
    </Layout>
  )
}

export default Index
